import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of} from "rxjs";
import {RaceRegistration} from "@model";
import {inject} from "@angular/core";
import {RaceRegistrationService} from "@services";

export const CompetitorRegistrationResolver: ResolveFn<Observable<RaceRegistration> | any> =
  (route: ActivatedRouteSnapshot,
   _: RouterStateSnapshot,
   raceRegistrationService: RaceRegistrationService = inject(RaceRegistrationService)): Observable<RaceRegistration> | any => {
    let competitorId: number | undefined = +route.queryParams['competitorId'] ? +route.queryParams['competitorId'] : undefined;
    return competitorId ? raceRegistrationService.findRegistrationByCompetitorID(competitorId) : of(undefined);
  }
